/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Direcao from '../../../../assets/logos/direcao-square.png'
import { useTracking } from 'react-tracking'

import { BiNotepad } from 'react-icons/bi'
import {
  BsChevronDown,
  BsChevronUp,
  BsArrowRight,
  BsCheck,
  BsCart,
  BsEnvelope,
} from 'react-icons/bs'
import { MdLock, MdOndemandVideo, MdOutlineMenuBook } from 'react-icons/md'
import ContentLoader from 'react-content-loader'
import history from '../../../../services/history'
import Progress from '../../../../components/Progress'
import _ from 'lodash'
import ProgressCircle from '../../../../components/ProgressCircle'
import {
  Container,
  ModuleContent,
  ConcludedLesson,
  ButtonWrapper,
  Expand,
  StartModule,
  BuyModule,
  LessonsWrapper,
  Lesson,
  CheckLesson,
  ProgressbarWrapper,
  ExpandDesktop,
  ProgressCircleWrapper,
  UnavailableContainer,
  WrapperContainer,
  BuildingStatus,
  TimeIcons,
  MessageModule,
} from './styles'
import Highlighted from '../../../../utils/highlight'

import { RootState } from '../../../../store/modules/rootReducer'

import { editPreference } from '../../../../store/modules/student/actions'
import { learningApi } from '../../../../services/api'
import ModalFreemium from '../../../../components/ModalFreemium'
import { TrackingSchemaTypes } from '../../../../tracking'
import { useAsyncFn } from 'react-use'
import { IAccessContentsRes } from './types'
import { formatSeconds } from 'utils/formatSeconds'
import TooltipWrapper from 'pages/MyQuestionBooks/components/TooltipWrapper'
interface ModuleAcordeonProps {
  orderId: string
  name: string
  term: string
  module: any
  courseId: string
  total: number
  course?: any // @TODO : Criar os Types
  loading: boolean
  buildingContent?: boolean
  progress?: number
  loadingProgressInfo?: boolean
}

const ModuleAcordeon: React.FC<ModuleAcordeonProps> = ({
  name,
  module,
  courseId,
  total,
  term,
  course,
  loading,
  progress,
  buildingContent,
  loadingProgressInfo,
}) => {
  const [openAcordeon, setOpenAcordeon] = useState<boolean>(false)
  const [completed, setCompleted] = useState<number>(0)
  const [lessons, setLessons] = useState<any>([])
  const [totalContent, setTotalContent] = useState<any>({})
  const [icon, setIcon] = useState<string>('')
  const [loadingLessons, setLoadingLessons] = useState<boolean>(false)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const { profile } = useSelector((state: RootState) => state.student)
  const token = localStorage.getItem('token')
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const dispatch = useDispatch()
  const { trackEvent } = useTracking()

  const [{ loading: loadingAccessContent }, handleAccessContent] = useAsyncFn(async () => {
    try {
      // @TODO : Ver se é necessário jogar essa chamada para uma svc
      const headers = {
        Authorization: `Bearer ${token}`,
      }
      const { data } = await learningApi.get<IAccessContentsRes>(
        `/course/${courseId}/module/${module.ref}/access-content`,
        { headers }
      )

      const contentExists =
        data?.lastViewed &&
        course?.children
          .filter((t) => t.ref === data?.lastViewed?.module?._id)
          .flatMap((t) =>
            t?.children?.flatMap((u) => ({
              module: t.ref,
              ref: u.ref,
              name: u.name,
              heading: u.heading,
            }))
          )
          .some((t) => t.ref === data?.lastViewed?.lesson?._id)

      if (contentExists) {
        handleContinue(data.lastViewed)
      } else {
        const content = data.contents.find((content) => content.hasContent)?.data
        handleInit(content)
      }
    } catch (err) {
      console.error('ops! ocorreu um erro' + err)
    }
  }, null)

  const hasContent = (() => {
    if (!module?.progressInfo) return false
    if (module?.children?.length === 0) return false
    if (!module.readingTime && !module.videoTime) return false

    return true
  })()

  const hasLessons = module?.children?.length > 0

  const handleContinue = (item: IAccessContentsRes['lastViewed']) => {
    if (course.isFreemium) {
      handleTrackFreemium()
    }

    const m = _.sortBy(course.children, 'order').find((t) => t.ref === item.module._id)
    const l = course.children
      .flatMap((t) => t.children.flatMap((u) => ({ ref: u.ref, name: u.name, heading: u.heading })))
      .find((t) => t.ref === item.lesson._id)

    const current = _.sortBy(m.children, 'order').findIndex((t) => t.ref === l.ref)

    const partitions = _.chunk(
      new Array(total).fill(1).map((t, i) => i),
      Math.ceil(total / 3)
    )
    const [Inicio, Meio = false, Fim = false] = partitions.map((t) => t.includes(current))

    trackEvent({
      event: TrackingSchemaTypes.AccessContent,
      properties: {
        Carreira: course.career,
        Instituicao: course.publicTender,
        Curso: course.name,
        Modulo: m.subject || m.name,
        Aula: l.heading || l.name,
        Capitulo: item.chapter.name,
        Formato: profile.preference === 0 ? 'Excerto' : 'Vídeo',
        Modo: 'Continuar',
        Atual: current + 1,
        Total: m.children.length,
        Porcentagem: course?.progress || 0,
        Inicio,
        Meio,
        Fim,
        Origem: 'Módulo',
      },
    })

    if (item && item.object.type) dispatch(editPreference(item.object.type !== 'video' ? 1 : 0))

    const url = `/course/${item.course._id}/module/${item.module._id}/lesson/${item.lesson._id}/chapter/${item.chapter._id}`
    return history.push(url)
  }

  const handleInit = (item: IAccessContentsRes['contents'][number]['data']) => {
    if (course.isFreemium) {
      handleTrackFreemium()
    }

    const m = _.sortBy(course.children, 'order').find((t) => t.ref === item.module._id)
    const l = course.children
      .flatMap((t) => t.children.flatMap((u) => ({ ref: u.ref, name: u.name, heading: u.heading })))
      .find((t) => t.ref === item.lesson._id)

    const current = _.sortBy(m.children, 'order').findIndex((t) => t.ref === l.ref)

    const partitions = _.chunk(
      new Array(total).fill(1).map((t, i) => i),
      Math.ceil(total / 3)
    )
    const [Inicio, Meio = false, Fim = false] = partitions.map((t) => t.includes(current))

    trackEvent({
      event: TrackingSchemaTypes.AccessContent,
      properties: {
        Carreira: course.career,
        Instituicao: course.publicTender,
        Curso: course.name,
        Modulo: m.subject || m.name,
        Aula: l.heading || l.name,
        Capitulo: item.chapter.name,
        Formato: profile.preference === 0 ? 'Excerto' : 'Vídeo',
        Modo: 'Começar',
        Atual: current + 1,
        Total: total,
        Porcentagem: course?.progress || 0,
        Inicio,
        Meio,
        Fim,
        Origem: 'Módulo',
      },
    })

    if (item?.objects.every((o) => o.match(/video/gi))) dispatch(editPreference(0))
    if (item?.objects.every((o) => o.match(/excerto/gi))) dispatch(editPreference(1))

    const url = `/course/${item?.course._id}/module/${item?.module._id}/lesson/${item?.lesson._id}/chapter/${item?.chapter._id}`
    return history.push(url)
  }

  const handleNotification = (_id: string) => {
    const url = `/recado/${_id}`
    return history.push(url)
  }

  const UnavailableModule = (available) => {
    if (available.type === 'launching')
      return (
        <ConcludedLesson>
          <span>Conteúdo disponível dia {available.date}</span>
        </ConcludedLesson>
      )

    if (available.type === 'sell')
      return (
        <ConcludedLesson>
          <BuyModule href={module.permanentLink} target="_blank">
            <BsCart size={18} />
            Comprar
          </BuyModule>
        </ConcludedLesson>
      )

    if (available.type === 'removed')
      return (
        <ConcludedLesson>
          <ConcludedLesson>
            <span>Conteúdo removido do edital</span>
          </ConcludedLesson>
        </ConcludedLesson>
      )

    if (available.type === 'sell')
      return (
        <ConcludedLesson>
          <ConcludedLesson>
            <span>Conteúdo removido do edital</span>
          </ConcludedLesson>
        </ConcludedLesson>
      )

    return (
      <ConcludedLesson>
        <span>Conteúdo indisponível</span>
      </ConcludedLesson>
    )
  }

  const RenderLessonCard = (lesson) => {
    const { available } = lesson

    const hasContent = !!lesson.first
    const isEmpty = hasContent === false

    const isFreemium = available.type === 'freemium' || (course?.isFreemium && lesson.order > 0)

    if (isFreemium && !course?.isSubscription)
      return (
        <ButtonWrapper>
          <StartModule onClick={() => setOpenModal(true)}>
            Acessar
            <MdLock size={18} />
          </StartModule>
        </ButtonWrapper>
      )

    if (isEmpty && available.date) {
      return (
        <ConcludedLesson>
          <p>
            Conteúdo disponível dia <strong>{available.date}</strong>
          </p>
        </ConcludedLesson>
      )
    }

    if (isEmpty) {
      return (
        <ConcludedLesson>
          <p>Conteúdo em atualização</p>
        </ConcludedLesson>
      )
    }

    return lesson.progress >= 95 ? (
      <>
        <StartModule onClick={() => handleInit(lesson.first)}>
          Estudar novamente
          <BsArrowRight size={18} />
        </StartModule>
        <CheckLesson checked style={{ marginLeft: '10px' }}>
          <BsCheck onClick={() => handleInit(lesson.first)} />
        </CheckLesson>
        <span onClick={() => handleInit(lesson.first)}>Concluída</span>
      </>
    ) : (
      <StartModule
        onClick={() =>
          lesson.progress === 0 && !lesson.last
            ? handleInit(lesson.first)
            : handleContinue(lesson.last)
        }
      >
        {lesson.progress > 0 || lesson.last ? 'Continuar' : 'Começar'} <BsArrowRight size={18} />
      </StartModule>
    )
  }

  const RenderModalFreemium = () => {
    const moduleInfo = {
      _id: module._id,
      name: module.name,
      icon: icon ?? Direcao,
      discount: module.discount,
      permanentLink: module.permanentLink,
      qtd_videos: totalContent.video?.amount,
      qtd_pdf: totalContent.excerto?.amount,
    }

    const courseInfo = {
      _id: course._id,
      name: course.name,
      icon: course.icon ?? Direcao,
      discount: course.discount,
      permanentLink: course.permanentLink,
      qtd_videos: course.total.videos?.amount,
      qtd_pdf: course.total.excertos?.amount,
    }

    return (
      <WrapperContainer>
        <ModalFreemium
          module={moduleInfo}
          course={courseInfo}
          setOpenModal={setOpenModal}
          subscription={course?.isFreemium && course?.isSubscription}
        />
      </WrapperContainer>
    )
  }

  const renderTimeIcons = (readingTime: number, videoTime: number) => {
    if (!readingTime && !videoTime) return null

    return (
      <TimeIcons>
        {readingTime > 0 && (
          <TooltipWrapper text="Tempo de leitura" position="right">
            <div className="wrapper">
              <MdOutlineMenuBook size={16} />
              {formatSeconds(readingTime)}
            </div>
          </TooltipWrapper>
        )}

        {videoTime > 0 && (
          <TooltipWrapper text="Tempo de vídeo" position="right">
            <div className="wrapper">
              <MdOndemandVideo size={16} />
              {formatSeconds(videoTime)}
            </div>
          </TooltipWrapper>
        )}
      </TimeIcons>
    )
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  const handleOpenAcordeon = useCallback(() => {
    if (!lessons || !lessons.length) {
      setLoadingLessons(true)
      setOpenAcordeon(true)
      learningApi
        .get(`/course/${courseId}/modules/${module.ref}/progress-info`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setTotalContent(response.data.total)
          setIcon(response.data.icon)
          setCompleted(response.data.completedLessons)
          setLessons(response.data.children)
          setLoadingLessons(false)
        })
        .catch((err) => {
          console.error('ops! ocorreu um erro' + err)
          setOpenAcordeon(false)
        })
    } else {
      setOpenAcordeon(true)
    }
  }, [courseId, lessons, module.ref, token])

  const handleTrackFreemium = () => {
    trackEvent({
      event: TrackingSchemaTypes.FreemiumAccessModule,
      properties: {
        email: profile.email,
        name: profile.name,
        telephone: profile.telephone,
        career: course.career,
        publicTenderName: course.publicTender,
        courseName: course.name,
        courseId: course._id,
        moduleName: module.subject,
      },
    })
  }

  const LoadingAccessContentComponent = useCallback(() => {
    return (
      <ContentLoader width={80} height={20} viewBox={'0 0 40 10'} {...LoaderProps}>
        <rect x="0" y="0" rx="0" ry="0" width="80" height="20" />
      </ContentLoader>
    )
  }, [LoaderProps])

  if (module.available?.lock) {
    return (
      <UnavailableContainer>
        <ModuleContent>
          <ProgressCircleWrapper>
            <ProgressCircle percentage={progress || 0} />
          </ProgressCircleWrapper>
          <div>
            <Highlighted name={name || ''} term={term || ''} />
            {UnavailableModule(module.available)}
            <ProgressbarWrapper>
              <Progress percentage={progress} page="module" />
            </ProgressbarWrapper>

            <ButtonWrapper>
              <StartModule onClick={() => handleAccessContent()}>
                {loadingAccessContent ? (
                  <LoadingAccessContentComponent />
                ) : (
                  <>
                    Acessar
                    <BsArrowRight size={18} />
                  </>
                )}
              </StartModule>
            </ButtonWrapper>
          </div>
        </ModuleContent>
      </UnavailableContainer>
    )
  } else {
    return (
      <Container>
        <ModuleContent>
          <ProgressCircleWrapper>
            {loading ? (
              <>
                <div style={{ margin: '5px auto' }}>
                  <ContentLoader width={100} height={80} viewBox={'0 0 34 36'} {...LoaderProps}>
                    <circle cx="16" cy="16" r="16" />
                  </ContentLoader>
                </div>
              </>
            ) : (
              <ProgressCircle percentage={progress || 0} />
            )}
          </ProgressCircleWrapper>
          <div>
            <Highlighted name={name || ''} term={term || ''} />
            {renderTimeIcons(module.readingTime, module.videoTime)}
            <ConcludedLesson>
              <StartModule disabled={!hasContent} onClick={() => handleAccessContent()}>
                {loadingAccessContent || loadingProgressInfo ? (
                  <>Carregando</>
                ) : hasContent ? (
                  <>
                    Acessar
                    <BsArrowRight size={18} />
                  </>
                ) : (
                  'Em construção'
                )}
              </StartModule>
              {buildingContent && <BuildingStatus>Em construção</BuildingStatus>}
              {module?.notification?._id ? (
                <MessageModule
                  disabled={!hasContent}
                  onClick={() => handleNotification(module?.notification?._id)}
                >
                  <>
                    Mensagem
                    <BsEnvelope size={18} />
                  </>
                </MessageModule>
              ) : (
                <></>
              )}
            </ConcludedLesson>
            <ProgressbarWrapper>
              {loading ? (
                <div style={{ width: '100%' }}>
                  <ContentLoader width={250} height={20} viewBox={'0 0 140 10'} {...LoaderProps}>
                    <rect x="0" y="0" rx="1" ry="1" width="300" height="20" />
                  </ContentLoader>
                </div>
              ) : (
                <Progress percentage={progress} page="module" />
              )}
            </ProgressbarWrapper>
            <ButtonWrapper>
              <StartModule disabled={!hasContent} onClick={() => handleAccessContent()}>
                {loadingAccessContent ? (
                  <LoadingAccessContentComponent />
                ) : hasContent ? (
                  <>
                    Acessar
                    <BsArrowRight size={18} />
                  </>
                ) : (
                  'Em construção'
                )}
              </StartModule>
              {hasLessons && (
                <Expand
                  onClick={() => (openAcordeon ? setOpenAcordeon(false) : handleOpenAcordeon())}
                >
                  {!openAcordeon ? (
                    <>
                      Expandir <BsChevronDown size={15} />{' '}
                    </>
                  ) : (
                    <>
                      Recolher <BsChevronUp size={15} />{' '}
                    </>
                  )}
                </Expand>
              )}
            </ButtonWrapper>
          </div>
          {hasLessons && (
            <ExpandDesktop
              onClick={() => (openAcordeon ? setOpenAcordeon(false) : handleOpenAcordeon())}
              value="expandAcordeon"
            >
              {!openAcordeon ? <BsChevronDown size={25} /> : <BsChevronUp size={25} />}
            </ExpandDesktop>
          )}
        </ModuleContent>
        {openAcordeon && (
          <>
            {loadingLessons ? (
              <ContentLoader width={'100%'} height={80} viewBox={'0 0 100% 80'} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="100%" height="80" />
              </ContentLoader>
            ) : (
              <>
                <ConcludedLesson>
                  <BiNotepad />
                  <span>
                    {completed ?? 0} de {lessons.length} aula{lessons.length > 1 ? 's' : ''}{' '}
                    concluída
                    {lessons.length > 1 ? 's' : ''}
                  </span>
                </ConcludedLesson>
                <LessonsWrapper>
                  {lessons.length ? (
                    lessons.map((lesson, idx) => {
                      const number = idx + 1
                      return (
                        <Lesson disabled={!!lesson.first} key={lesson.ref}>
                          <h3>
                            {number < 10 ? `0${number}` : number} - {lesson.heading || lesson.name}
                          </h3>
                          {renderTimeIcons(lesson.readingTime, lesson.videoTime)}
                          <div className="card-wrapper">
                            {RenderLessonCard({ ...lesson, total: lessons.length })}
                          </div>
                        </Lesson>
                      )
                    })
                  ) : (
                    <h4>Conteúdo indisponível</h4>
                  )}
                </LessonsWrapper>
              </>
            )}
          </>
        )}
        {openModal && RenderModalFreemium()}
      </Container>
    )
  }
}

export default ModuleAcordeon
